import { message } from "utilities/message/message";
import { err, ok } from "utilities/result";
import { attempt } from "@/utilities/attempt";
import { getUserCredentials } from "@/utilities/message/user";

const API_URL = process.env.GATSBY_API_URI;

const startGamingSession = async (gameId: string, isDesktop: boolean) => {
  const [response, error] = await message("start-gaming-session", {
    gameId,
    desktop: isDesktop,
  });

  if (error) {
    return err(error);
  }

  return ok(response);
};

const startDemoGamingSession = async (
  userId: string,
  gameId: string,
  isDesktop: boolean,
) => {
  const { token } = getUserCredentials();
  const response = await fetch(`${API_URL}/casino/demo`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({
      userId,
      gameId,
      desktop: isDesktop,
    }),
  });

  if (!response?.ok) {
    return err(response);
  }

  const json = await attempt(response.json());

  if (!json.ok) {
    return err(json.error);
  }

  return ok(json.data);
};

const endGamingSession = async (token: string) => {
  const [response, error] = await message("end-gaming-session", {
    token,
  });

  if (error) {
    return err(error);
  }

  return ok(response);
};

const endAllGamingSessions = async () => {
  const [response, error] = await message("end-all-gaming-sessions");

  if (error) {
    return err(error);
  }

  return ok(response);
};

export const casinoService = {
  startGamingSession,
  startDemoGamingSession,
  endGamingSession,
  endAllGamingSessions,
};
